import axios from '@/libs/api.request'

export const getAssistpersonlist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/assistperson/assistperson/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const getAssistsetkpilist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/assistperson/set/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const getuserlist_assist = (role, dept, id) => {
  return axios.request({
    url: '/v1/assistperson/users/',
    method: 'get',
    params: {
      role,
      dept,
      id
    }
  })
}

export const operationAssistuserkpi = (data, meth) => {
  return axios.request({
    url: '/v1/assistperson/users/',
    method: meth,
    data
  })
}

export const getAssistkpilist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/assistperson/kpi/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationAssistperson = (data, meth) => {
  return axios.request({
    url: '/v1/assistperson/assistperson/',
    method: meth,
    data
  })
}
export const operationAssistkpi = (data, meth) => {
  return axios.request({
    url: '/v1/assistperson/kpi/',
    method: meth,
    data
  })
}

export const operationAssistInfo = (data, meth) => {
  return axios.request({
    url: '/v1/assistperson/info/',
    method: meth,
    data
  })
}

export const importexceldata = (data, meth) => {
  return axios.request({
    url: '/v1/assistperson/import/',
    method: meth,
    data
  })
}
